export default __webpack_public_path__ + "static/angebot-brautstyling-2024-e6a994d7d85a41dfd5b02c8d248b9a9c.pdf";